<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="M907 271zm44.2 452.5c.7-90.3-72-164-162.3-164.7h-4.1c-8.7.1-17.4.8-26 2.1l-63.4-93.4 4.4-3.8 3.5-3c87.8-89.3 87.8-232.4 0-321.7-89.3-87.8-232.4-87.8-321.7 0-87.7 89.2-87.7 232.3 0 321.6 7.4 7.4 15.4 14.2 24 20.2l-56.9 95.4c-25.3-11.4-52.7-17.3-80.5-17.4-108 1.1-195.2 88.3-196.3 196.3.2 51.9 21.1 101.6 58.1 138 36.6 36.8 86.3 57.6 138.1 57.8 51.5-1 100.6-21.8 137.1-58.1 76.2-74.6 77.4-196.9 2.8-273-.9-.9-1.8-1.9-2.8-2.8-1.8-1.8-3.9-3.9-6.2-5.9l60.4-100.2c26.5 10.1 54.7 15.2 83 15.1 35.8 0 71.1-8.5 103-24.8l54.6 80.6c-50 29.5-80.4 83.6-79.6 141.8-8.7 91.3 58.2 172.4 149.5 181.1 91.3 8.7 172.4-58.2 181.1-149.5 1.2-10.6 1.2-21.2.2-31.7zm-545 31.6v.8-.8z" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
